// Copyright (c) Move Closer 2022.

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface ITabsService<Item> {
  addTabs (tabs: Item[]): void
  getTabs (): Item[]
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface TabItem {
  label: string
  value: string
  priority: number
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const TabsServiceType = Symbol.for('ITabsService')
